var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 9.27344V5.53516C19.207 5.53516 19.207 5.53516 19.207 5.53516C18.1758 5.53516 17.1875 5.23438 16.3711 4.67578C15.168 3.90234 14.3086 2.65625 14.0508 1.23828C13.9648 0.9375 13.9648 0.636719 13.9648 0.335938C13.9648 0.292969 13.9648 0.292969 13.9648 0.25H10.1836V15.2891C10.1836 17.0508 8.72266 18.5117 6.96094 18.5117C5.19922 18.5117 3.73828 17.0508 3.73828 15.2891C3.73828 13.5273 5.19922 12.0664 6.96094 12.0664C7.30469 12.0664 7.60547 12.1094 7.94922 12.2383V8.37109C7.60547 8.32812 7.30469 8.28516 6.96094 8.28516C3.09375 8.28516 0 11.4219 0 15.2891C0 19.1562 3.09375 22.25 6.96094 22.25C10.8281 22.25 13.9648 19.1562 13.9648 15.2891V7.59766C15.4258 8.67188 17.2305 9.27344 19.207 9.27344H19.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.56f64bbf74091c3794fedd837eb59579.svg";
export { ForwardRef as ReactComponent };